<template>
  <div class="page-view">
    <div class="scroll-view-wrapper new_exercise">
      <div class="new_exercise_header" :class="{ app: isApp }">
        <div class="head">
          <div class="study_time">
            <template v-if="!isLogin">
              <div class="default_title">赋能医生，守护生命</div>
            </template>
            <template v-else>
              <div>
                在好医术第<span>{{ learnInfo.day || 0 }}</span
                >天，共学<span>{{ learnInfo.studyTime || 0 }}</span
                >小时
              </div>
            </template>
          </div>
          <i class="ranking" @click="pageAction"></i>
        </div>
      </div>
      <!-- 学习统计 -->
      <div class="new_exercise_container">
        <div class="study_num">
          <div class="item lesson">
            <p>
              <strong>{{ learnInfo.albumCount }}</strong
              >节
            </p>
            <p class="text">课程</p>
          </div>
          <div class="item train">
            <p>
              <strong>{{ learnInfo.meetingCount }}</strong
              >次
            </p>
            <p class="text">训练/共学营</p>
          </div>
          <div class="item exam">
            <p>
              <strong>{{ learnInfo.questionCount }}</strong
              >题
            </p>
            <p class="text">病例练习</p>
          </div>
        </div>

        <!-- 日历 -->
        <div class="calendar">
          <h-calendar
            :date="new Date($store.state.chooseDate)"
            :scheduleMap="calendarSchedule"
            @change="calendarChange"
          />
        </div>

        <!-- 训练营 -->
        <div class="training_camp-tabs">
          <div
            class="training_camp-tab-item"
            :class="{ active: tab.value === activeTab }"
            v-for="tab in trainingCampTabs"
            :key="tab.value"
            @click.stop="selectTrainingCamp(tab.value)"
          >
            <span class="text">{{ tab.label }}</span>
            <i class="dot" v-show="tab.dot"></i>
          </div>
        </div>
        <div class="training_camp-tab-container" ref="tabContainerRef">
          <template v-if="!isLogin && activeTab != 'INDIVIDUAL'">
            <no-user />
          </template>
          <template v-else-if="activeTab == 'INDIVIDUAL'">
            <div
              class="medicaseImg"
              v-show="departmentId == 2"
              @click.stop="toMedicase"
            >
              <img src="@/assets/img/exercise/medicase.jpg" alt="" />
            </div>
          </template>
          <!-- 列表 -->
          <template v-else-if="trainingCampList.length">
            <div
              class="training_camp-info"
              :class="{ active: activeId === item.exerciseId }"
              v-for="item in trainingCampList"
              :key="item.exerciseId"
            >
              <div
                @click.stop="selectTrainingCampItem(item.exerciseId)"
                class="training_camp-info__header"
              >
                <div class="left">
                  <div class="progress">
                    <van-circle
                      :stroke-width="160"
                      :current-rate="
                        (Number(item.current) / Number(item.total)) * 100
                      "
                      color="#6183F2"
                      layer-color="#EDEDF0"
                      :rate="30"
                      :speed="100"
                      :text="item.current + '/' + item.total"
                    />
                  </div>
                  <div class="title">
                    <p
                      :class="{ active: activeId === item.exerciseId }"
                      class="text-overflow exerciseName"
                    >
                      {{ item.exerciseName }}
                    </p>
                    <!-- <div v-show="activeId === item.exerciseId">
                      <e-avatar-list :list="item.enrollment.avatars" :num="item.enrollment.userCount"
                        :text="activeTab === 'INDIVIDUAL' ? '已练习' : '已报名'"
                      />
                    </div> -->
                  </div>
                </div>
                <i
                  class="icon"
                  :class="{ active: activeId === item.exerciseId }"
                ></i>
              </div>

              <div
                class="training_camp-info__main"
                v-if="activeId === item.exerciseId"
              >
                <!-- <div class="training_camp-info__remind">
                  <div class="wrapper" v-if="currentTariningCampData.planType != 'TODAY'">
                    <i class="icon"></i>
                    <template v-if="item.status === 'OPEN' && currentTariningCampData.planType != 'TODAY'">
                      <p v-if="activeTab !== 'INDIVIDUAL'">完成该{{ activeTab === 'TEAM' ? '共学营' : "训练营"}}预计需要{{item.totalDayCount}}天</p>
                      <p v-else>完成该专题预计需要{{item.totalDayCount}}天</p>
                    </template>
                    <template v-else-if="item.status === 'NOT_STARTED'">
                      <p v-if="activeTab !== 'INDIVIDUAL'">当前{{ activeTab === 'TEAM' ? '共学营' : "训练营"}}尚未开营，开营日期：{{item.startedDate}}</p>
                      <p v-else>当前专题未开始，开营日期：{{item.startedDate}}</p>
                    </template>
                    <template v-else-if="item.status === 'CLOSED'">
                      <p v-if="activeTab !== 'INDIVIDUAL'">当前{{ activeTab === 'TEAM' ? '共学营' : "训练营"}}已闭营，快去复习下所学知识吧~</p>
                      <p v-else>当前专题已结束，快去复习下所学知识吧</p>
                    </template>
                  </div>
                </div> -->
                <!-- 里程碑 -->
                <mile-stone
                  :list="currentTariningCampData.plans"
                  @change="mileStoneChangeAction"
                  v-show="currentTariningCampData.planType != 'TODAY'"
                  :totalDayCount="item.totalDayCount"
                  :currentDayCount="item.currentDayCount"
                  :currentPlanDate="currentPlanDate"
                />

                <template v-if="currentTasks.length > 0">
                  <study-task
                    :id="currentTariningCampData.exerciseId"
                    :taskList="currentTasks"
                    :summary="currentSummary"
                    :disabled="item.status === 'NOT_STARTED'"
                    :taskStatus="currentTaskStatus"
                    @task="handleTaskModal"
                    :planType="planType"
                    v-if="loaded"
                  />
                </template>
                <template v-else>
                  <no-task />
                </template>
              </div>
            </div>
          </template>
          <template v-else-if="trainingCampList.length === 0 && loaded">
            <no-buy />
          </template>
        </div>
        <!-- 推荐 -->
        <recommend
          :ios="ios"
          v-show="activeTab != 'INDIVIDUAL' && recommendList.length"
          :activeTab="activeTab"
          :list="recommendList"
        />
      </div>

      <div class="ui-safe-area-inset"></div>
    </div>
    <!-- 里程碑未解锁 -->
    <unlock-modal
      :text="offsetReady || overdueDay"
      :visible="unlockModalVisible"
      @close="showUnlockModal"
      @toTask="handleToTask"
      :planType="planType"
    />
    <!-- 里程碑待解锁 -->
    <wait-lock-modal
      :visible="waitlockModalVisible"
      :time="unlockTime"
      @close="showWaitlockModal"
    />
    <!-- 训练营未开始 -->
    <no-start-modal
      :visible="noStartModalVisible"
      :time="noStartTime"
      :activeTab="activeTab"
      @close="showNoStartModal"
    />
  </div>
</template>

<script setup>
import { onMounted, ref, getCurrentInstance, nextTick, watch } from 'vue'
import utils from '@/public/utils'
import { hostPath } from '@utils/basePath'
import { exerReq } from '@/api'
import { getLearnInfo, getDepId } from '@/api/user'
import now from '@/components/exercise/utils/time/now'
import { dateFmt } from '@/components/exercise/utils/time'

import HCalendar from '@/components/exercise/h-calendar/index.vue'
import NoUser from '@/components/exercise/no-user/index.vue'
import NoBuy from '@/components/exercise/no-buy/index.vue'
import NoTask from '@/components/exercise/no-task/index.vue'
import Recommend from '@/components/exercise/recommend/index.vue'
// 已报名信息隐藏了
// import EAvatarList from '@/components/exercise/avatar-list/index.vue'
import MileStone from '@/components/exercise/milestone/index.vue'
import StudyTask from '@/components/exercise/study-task/index.vue'
import UnlockModal from '@/components/exercise/unlock-modal/index.vue'
import WaitLockModal from '@/components/exercise/wait-lock-modal/index.vue'
import NoStartModal from '@/components/exercise/no-start-modal/index.vue'
import lodashFind from 'lodash/find'
import cloneDeep from 'lodash/cloneDeep'
import app from '../../widget/app'
import { appPort, jumpModuleApp } from '@/widget'
import { useRouter, useRoute } from 'vue-router'
import { getTokenObj } from '@/widget/index'
const {
  proxy: { $showLoading, $hideLoading, $toast, $store }
} = getCurrentInstance()
const isApp = ref(utils.isApp())
const userId = ref(utils.getUserId())
// 是否登录
const isLogin = ref(Boolean(getTokenObj().token))
const currentRoute = useRoute()
const $router = useRouter()
const trainingCampTabs = ref([])
const activeTab = ref('')
// OMO 病历练习、 线上共学营 tab 切换
const selectTrainingCamp = val => {
  if (activeTab.value !== val) {
    activeTab.value = val
    activeId.value = 0
    $router.replace({
      path: currentRoute.path,
      query: {
        type: val
      }
    })
    if (activeTab.value !== 'INDIVIDUAL') {
      getExerciseHot()
    }
    getExerciseList()
  }
}
const getExerciseTabs = depId => {
  let tabs = null
  if (depId === 1) {
    tabs = [
      {
        label: 'OMO训练营',
        value: 'OMO',
        dot: false
      },
      {
        label: '线上共学营',
        value: 'TEAM',
        dot: false
      },
      {
        label: '病例练习',
        value: 'INDIVIDUAL',
        dot: false
      }
    ]
  } else if (depId === 2) {
    tabs = [
      {
        label: '病例练习',
        value: 'INDIVIDUAL',
        dot: false
      },
      {
        label: '线上共学营',
        value: 'TEAM',
        dot: false
      }
      // , {
      //   label: 'OMO训练营',
      //   value: 'OMO',
      //   dot: false
      // }
    ]
  } else if (depId === 11 || depId === 9) {
    tabs = [
      {
        label: '线上共学营',
        value: 'TEAM',
        dot: false
      },
      {
        label: 'OMO训练营',
        value: 'OMO',
        dot: false
      },
      {
        label: '病例练习',
        value: 'INDIVIDUAL',
        dot: false
      }
    ]
  } else if (depId === 13) {
    tabs = [
      {
        label: '线上共学营',
        value: 'TEAM',
        dot: false
      },
      {
        label: '病例练习',
        value: 'INDIVIDUAL',
        dot: false
      },
      {
        label: 'OMO训练营',
        value: 'OMO',
        dot: false
      }
    ]
  } else if (depId === 16) {
    tabs = [
      {
        label: '线上共学营',
        value: 'TEAM',
        dot: false
      },
      {
        label: 'OMO训练营',
        value: 'OMO',
        dot: false
      },
      {
        label: '病例练习',
        value: 'INDIVIDUAL',
        dot: false
      }
    ]
  } else {
    tabs = [
      {
        label: 'OMO训练营',
        value: 'OMO',
        dot: false
      },
      {
        label: '线上共学营',
        value: 'TEAM',
        dot: false
      },
      {
        label: '病例练习',
        value: 'INDIVIDUAL',
        dot: false
      }
    ]
  }
  trainingCampTabs.value = tabs
  activeTab.value = currentRoute.query.type || tabs[0].value
  return new Promise(resolve => {
    resolve(true)
  })
}

// 当前查看训练营ID
const activeId = ref(Number(currentRoute.query.id) || 0)
const trainingCampList = ref([])
// 未开营的时间
const noStartTime = ref('')
// 当前展开的训练营的数据
const currentTariningCampData = ref({})
// 展开列表
const dateNow = dateFmt(new Date(), 'yyyy/MM/dd')
$store.commit('SET_CHOOSEDATE', dateNow)

const currentPlan = ref({})
const currentPlanDate = ref(dateNow) // 当前展示里程碑日期
// 选择训练营、病历练习
const selectTrainingCampItem = id => {
  if (activeId.value === id) {
    activeId.value = 0
    $router.replace({
      name: currentRoute.name,
      query: {
        id: activeId.value || '',
        type: currentRoute.query.type || activeTab.value
      }
    })
  } else {
    activeId.value = id
    seleteCurrentData()
  }
  scrollToView()
}

const currentTasks = ref([]) // 当前展开的里程碑任务
const currentSummary = ref([]) // 当前里程碑任务类型
const currentTaskStatus = ref('') // 当前里程碑任务状态
const overdueDay = ref('') // 逾期未完成任务日期
const unlockTime = ref('') // 未解锁里程碑开始时间
const planType = ref('') // 里程碑类型
const offsetReady = ref('') // 第几关未完成
let queryPlanId = /^\d+$/.test(currentRoute.query.planId)
  ? currentRoute.query.planId
  : ''
const planId = ref(Number(queryPlanId || 0)) // 当前计划Id
// 当前展开的训练营、病历练习
const seleteCurrentData = () => {
  const data = lodashFind(trainingCampList.value, {
    exerciseId: activeId.value
  })
  currentTariningCampData.value = cloneDeep(data)
  let overduePlan
  // 逾期里程碑
  planType.value = data.planType
  offsetReady.value = ''
  if (data.planType === 'STAGE') {
    overduePlan = lodashFind(data.plans, { status: 'READY' }) || data.plans[0]
    if (overduePlan) {
      offsetReady.value = String(overduePlan.offset)
    }
  } else {
    overduePlan = lodashFind(data.plans, { status: 'OVERDUE' })
  }
  if (overduePlan) {
    overdueDay.value = overduePlan.exercisedDate
  }
  getTasks()
  noStartTime.value = dateFmt(new Date(data.startedDate), 'yyyy年MM月dd日')
  // 当前训练营
  scrollToView()
}
// 获取当前里程碑任务
const getTasks = () => {
  if (!currentTariningCampData.value.plans) {
    return
  }
  // 当前日历选中日期中的里程碑数据
  let data = null
  if (planId.value) {
    data = lodashFind(currentTariningCampData.value.plans, {
      planId: planId.value
    })
  } else {
    data = lodashFind(currentTariningCampData.value.plans, {
      exercisedDate: $store.state.chooseDate
    })
  }
  if (data) {
    currentPlan.value = data
    currentPlanDate.value = data.exercisedDate
  } else {
    // 里程碑数据
    let dataPlan =
      lodashFind(currentTariningCampData.value.plans, {
        exercisedDate: dateNow
      }) || currentTariningCampData.value.plans[0]
    if (dataPlan) {
      currentPlan.value = cloneDeep(dataPlan)
      currentPlanDate.value = dataPlan.exercisedDate
    } else {
      currentPlan.value = {
        tasks: []
      }
    }
  }
  let query = currentRoute.query
  planId.value = currentPlan.value.planId
  $router.replace({
    path: currentRoute.path,
    query: {
      ...query,
      id: activeId.value || '',
      planId: planId.value || ''
    }
  })
  // 未解锁待解锁时间
  if (currentPlan.value.status === 'LOCKED') {
    unlockTime.value = currentPlan.value.exercisedDate
  }
  currentTasks.value = currentPlan.value.tasks
  currentTaskStatus.value = currentPlan.value.status
  currentSummary.value = currentPlan.value.summaries
}
// 日历选择日期
const calendarChange = value => {
  // 同一天
  if ($store.state.chooseDate === value.dateFormat) {
    return false
  }
  planId.value = 0
  // 是否有在看的训练营、病历练习
  $store.commit('SET_CHOOSEDATE', value.dateFormat)
  if (activeId.value) {
    getTasks()
  }
  // 是否有计划
  if (value.hasSchedule) {
    return false
  }
  getExerciseCalendar(value)
}
// 获取练习日历
const calendarSchedule = ref({})
const getExerciseCalendar = async ({ year, month, date }) => {
  const params = {
    year,
    month: month + 1,
    date
  }
  const res = await exerReq.getExerciseCalendar(params)
  if (res.code === 200) {
    const data = res.data
    const obj = {}
    data.forEach(item => {
      obj[item.businessDate] = item.todo
    })
    calendarSchedule.value = obj
  } else {
    $toast(res.message)
  }
}
// 列表是否加载完成
const loaded = ref(false)
// 监听列表数据变化，更新后重新获取当前展示任务
watch(
  () => loaded.value,
  () => {
    if (activeId.value) {
      getTasks()
    }
  }
)
// 获取练习列表
const getExerciseList = async () => {
  if (activeTab.value === 'INDIVIDUAL') {
    // 病例练习不获取数据
    return
  }
  const params = {
    exerciseType: activeTab.value
  }
  $showLoading()
  loaded.value = false
  const res = await exerReq.getExerciseList(params)
  $hideLoading()
  loaded.value = true
  if (res.code === 200) {
    const data = res.data
    trainingCampList.value = data
    const obj = lodashFind(trainingCampList.value, {
      exerciseId: activeId.value
    })
    if (obj) {
      seleteCurrentData(obj)
    }
  } else {
    $toast(res.message)
  }
}
// 选择里程碑
const mileStoneChangeAction = item => {
  // currentTasks.value = cloneDeep(item.tasks)
  currentPlanDate.value = item.exercisedDate
  planId.value = item.planId
  getTasks()
}
// 展示逾期里程碑任务
const handleToTask = () => {
  showUnlockModal(false)
  $store.commit('SET_CHOOSEDATE', overdueDay.value)
  mileStoneChangeAction({ exercisedDate: overdueDay.value })
}

const tabContainerRef = ref(null)
const scrollToView = () => {
  nextTick(() => {
    const dom = tabContainerRef.value
    const [node] = Array.from(dom.childNodes).filter(
      n => n.classList && n.classList.contains('active')
    )
    if (node) {
      window.scrollTo({
        top: node.offsetTop,
        behavior: 'smooth'
      })
    }
  })
}

const handleTaskModal = val => {
  if (val === 0) {
    showNoStartModal(true)
  } else if (val === 1) {
    showWaitlockModal(true)
  } else if (val === 2) {
    showUnlockModal(true)
  }
}

// 未解锁弹窗
const unlockModalVisible = ref(false)
const showUnlockModal = val => {
  unlockModalVisible.value = val
}

// 待解锁弹窗
const waitlockModalVisible = ref(false)
const showWaitlockModal = val => {
  waitlockModalVisible.value = val
}

// 未开始弹窗
const noStartModalVisible = ref(false)
const showNoStartModal = val => {
  noStartModalVisible.value = val
}

const pageAction = () => {
  if (utils.isApp()) {
    app.postMessage({
      type: 'h5',
      url: `${hostPath}/learn/exercise/rank`
    })
  } else {
    $router.push('/exercise/rank')
  }
}
// 学习统计
const learnInfo = ref({})
const getUserInfo = () => {
  getLearnInfo({
    userId: userId.value
  }).then(res => {
    if (res.code === 200) {
      learnInfo.value = res.data
    } else {
      $toast(res.message)
    }
  })
}
let depId = 1
const departmentId = ref(0)
const getUseDep = () => {
  getDepId(userId.value).then(res => {
    if (res.code === 200) {
      depId = res.data.depId
      departmentId.value = depId
      nextTick(() => {
        getPageInfo()
      })
    } else {
      $toast(res.message)
    }
  })
}
const getPageInfo = () => {
  getExerciseTabs(depId || 1).then(res => {
    if (res && userId.value && !windowUpdate.value) {
      getExerciseCalendar(now)
      getExerciseList()
    }
    if (activeTab.value !== 'INDIVIDUAL') {
      // 病历练习没有推荐
      getExerciseHot()
    }
  })
}
// 推荐
const recommendList = ref([])
const ios = utils.ios()
const getExerciseHot = async () => {
  loaded.value && $showLoading()
  const res = await exerReq.getExerciseHot({
    exerciseType: activeTab.value
  })
  if (res.code === 200) {
    loaded.value && $hideLoading()
    const data = res.data
    recommendList.value = data
  } else {
    $toast(res.message)
  }
}
const toMedicase = () => {
  if (appPort()) {
    jumpModuleApp({
      typeId: 'h5',
      url: `${hostPath}/learn/medicase`
    })
  } else {
    $router.push({
      name: 'medicaseHome'
    })
  }
}
const windowUpdate = ref(false)
onMounted(() => {
  window.updateListData = () => {
    if (userId.value) {
      windowUpdate.value = true
      getExerciseCalendar(now)
      getExerciseList()
    }
  }
  if (isLogin.value) {
    getUseDep()
    getUserInfo()
  } else {
    getPageInfo()
  }
})
</script>

<style lang="scss" scoped>
@import '~@/components/exercise/style/default.scss';
@import './index.scss';
</style>
